<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-mb-card tm-mb-curt-card">
    <v-row class="com-mb-card-contents-none-border" no-gutters>
      <v-sheet
        outlined
        v-for="obs in tmRdBsnList.curt.category"
        :key="obs.name"
        class="tm-mb-curt-sub-item"
      >
        <div
          class="tm-mb-latest-center tm-mb-rain-color tm-mb-curt-sub-item__name"
          :bg-color="obs.bgColor"
        >
          {{ obs.title }}
        </div>
        <v-divider></v-divider>
        <div class="tm-mb-latest-center tm-mb-curt-sub-item__data">
          {{ obs.value }}
          {{ obs.unit }}
        </div>
      </v-sheet>
    </v-row>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [MB]レーダ流域 最新観測値カード
 * TmRdBsnCurt.vue
 * @author ILUKE
 */

export default {
  name: "tm-rd-bsn-curt",
  data() {
    return {
      /** 文字列リソース */
      text: {
        rnInc: "累加雨量",
      },
    };
  },
  computed: {
    /**
     * レーダ流域 取得
     */
    tmRdBsnList: {
      get() {
        let selectedTm = this.$store.state.Telemeter.selectedTm;
        selectedTm.curt.category[2].title = this.text.rnInc;
        return selectedTm;
      },
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
